<template>
  <el-dialog title="Criar Assinatura Eletronica" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="920px">
    <el-form ref="form" size="small" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="Tipo de documentação">
            <el-select
              v-model="form.tipo"
              auto-complete="off"
              clearable
              placeholder
              size="small"
              style="width: 100%;"
              @change="limparCampos"
            >
              <el-option
                v-for="item in tiposDeDocumentos"
                :disabled="!tipoDocumentoDesativado(item.data)"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item v-if="exibirSelecionarDocumento" style="margin-top: 5px">
            <template slot="label">
              {{ labelDocumento }}
            </template>
            <el-select
              v-model="form.documento"
              :remote-method="recuperarDocumentosSelect"
              :loading="loadingDocumento"
              value-key="id"
              placeholder=""
              loading-text="Carregando Documentos"
              no-data-text="Nenhum Documento encontrado"
              filterable
              clearable
              @clear="form.documento = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaDocumentos"
                :key="item.id"
                :label="`${item.nome} - ${getLabel(item.tipo)}`"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item style="margin-top: 5px" v-if="exibirSelecionarAluguel">
            <template slot="label">
              ID do Aluguel
            </template>
            <el-select
              v-model="form.aluguel"
              :remote-method="recuperarAlugueisSelect"
              :loading="loadingAlugueis"
              @change="listarEnvolvidosAluguelHandler"
              value-key="id"
              placeholder=""
              loading-text="Carregando Alugueis"
              no-data-text="Nenhum aluguel encontrado"
              filterable
              clearable
              @clear="form.aluguel = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaAlugueis"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 5px" v-if="exibirSelecionarVenda">
            <template slot="label">
              ID do Contrato de Venda
            </template>
            <el-select
              v-model="form.venda"
              :remote-method="recuperarVendasSelect"
              :loading="loadingVendas"
              @change="listarEnvolvidosVendaHandler"
              value-key="id"
              placeholder=""
              loading-text="Carregando Alugueis"
              no-data-text="Nenhum aluguel encontrado"
              filterable
              clearable
              @clear="form.venda = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaVendas"
                :key="item.id"
                :label="`${item.imovel.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 5px" v-if="exibirSelecionarImovelAluguel">
            <template slot="label">
              ID do Imóvel de Aluguel
            </template>
            <el-select
              v-model="form.imovelAluguel"
              :remote-method="recuperarImoveisAluguelSelect"
              :loading="loadingImoveisAluguel"
              @change="listarEnvolvidosImovelAluguelHandler"
              value-key="id"
              placeholder=""
              loading-text="Carregando Imóveis de Aluguel"
              no-data-text="Nenhum imóvel de aluguel"
              filterable
              clearable
              @clear="form.imovelAluguel = undefined"
              remote
              reserve-keyword
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaImoveisAluguel"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${ item.endereco }(${item.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 5px" v-if="exibirSelecionarImovelVenda">
            <template slot="label">
              ID do Imóvel de Venda
            </template>
            <el-select
              v-model="form.imovelVenda"
              :remote-method="recuperarImoveisVendaSelect"
              :loading="loadingImoveisVenda"
              @change="listarEnvolvidosImovelVendaHandler"
              value-key="id"
              placeholder=""
              loading-text="Carregando Imóveis de Venda"
              no-data-text="Nenhum Imóvel de Venda"
              filterable
              clearable
              @clear="form.imovelVenda = undefined"
              remote
              reserve-keyword
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaImoveisVenda"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${ item.endereco }(${item.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 5px" v-if="exibirSelecionarVistoria">
            <template slot="label">
              Vistoria
            </template>
            <el-select
              v-model="form.vistoria"
              :remote-method="recuperarVistoriasSelect"
              :loading="loadingVistorias"
              @change="listarEnvolvidosVistoriaHandler"
              value-key="id"
              placeholder="ID do Aluguel"
              loading-text="Carregando Vistorias"
              no-data-text="Nenhuma vistoria encontrada"
              filterable
              clearable
              @clear="form.vistoria = undefined"
              remote
              reserve-keyword
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaVistorias"
                :key="item.id"
                :label="`Vistoria de ${item.tipo[0] + item.tipo.slice(1).toLowerCase().replace('_', ' ')} - Aluguel: ${item.aluguel.idNaImobiliaria}, Imovel: ${item.imovel.idNaImobiliaria}, Status: ${ item.status[0] + item.status.slice(1).toLowerCase()}`"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="margin-top: 5px" v-if="this.form.tipo">
          <el-form-item>
            <template slot="label">
              Validade da Assinatura
            </template>
            <el-select
              v-model="form.diasValidade"
              size="small"
              style="width: 100%;"
            >
              <el-option :value="7" label="07 dias"></el-option>
              <el-option :value="15" label="15 dias"></el-option>
              <el-option :value="30" label="30 dias"></el-option>
              <el-option :value="60" label="60 dias"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="isExibirEnvolvidos">
        <el-col :span="24">
          <el-form-item >
            <template slot="label">
              Signatarios
              <span style="font-size: 12px; font-style: italic;">(Ao clicar no signatario abaixo, ele participará da assinatura.)</span>
            </template>
            <div style="display: flex; flex-direction: column; gap: 2px; padding: 10px 0px;">
              <div v-for="(item, index) in listaEnvolvidos" :key="index"
                style="padding: 2px 8px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
              >
                <div style="background-color: azure; padding: 2px 8px; cursor: pointer; display: flex; flex-direction: row; justify-content: space-between; align-items: center; width: 100%"
                @click="adicionarRemoverSignatario(item)">
                  <div style="display: flex; flex-direction: row; justify-content: space-between; gap: 5px;">
                    <span v-if="item.cliente">{{ item.cliente.nome }}</span>
                    <span v-else>{{ item.vistoriador.nome }}</span>
                    <span style="font-weight: 600;">{{ `(${item.tipoSignatario[0] + item.tipoSignatario.slice(1).toLowerCase()})` }}</span>
                  </div>
                  <i v-if="form.signatarios.includes(item)" class="el-icon-success" style="color: chartreuse; font-size: 18px;"></i>
                </div>

                <div v-if="form.signatarios.includes(item)">
                  <el-select
                    v-model="item.modoAutenticacao"
                    style="width: 100%;"
                    placeholder="Modo autenticação"
                    size="small"
                  >
                  <el-option
                    v-for="authMode in authModes"
                    :key="authMode.id"
                    :label="authMode.label"
                    :value="authMode.data"
                  />
                  </el-select>
                </div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column;" v-if="form.tipo === 'VISTORIAS'">
              <div style="display: flex; flex-direction: row; align-items: center; gap: 2px;">
                <span>Testemunhas</span>
                <el-button icon="el-icon-plus" type="text" @click="exibirFormularioTestemunha"/>
              </div>
              <div style="width: calc(100% - 30%); display: flex; flex-direction: row; align-items: center; gap: 5px;" v-if="visibilidadeAdicionarTestemunha">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="Nome">
                      <el-input size="small" v-model="testemunha.nome"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="E-mail">
                      <el-input size="small" v-model="testemunha.email"/>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label=" ">
                      <el-button @click="adicionarTestemunha" type="success" circle icon="el-icon-check"></el-button>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label=" ">
                      <el-button @click="fecharFormularioTestemunha" type="danger" circle icon="el-icon-close"></el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div style="padding: 2px 16px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
                <div v-for="item in testemunhas" :key="item.id" style="background-color: azure; padding: 2px 8px; display: flex; flex-direction: row; justify-content:space-between; align-items: center; width: 100%;">
                  <div style="display: flex; flex-direction: row; gap: 10px;">
                    <span>{{ item.nome }}</span> | <span>Email: {{ item.email }}</span>
                  </div>
                  
                  <div style="display: flex; flex-direction: row; justify-content: center; gap: 5px;">
                    <el-select
                      v-model="item.modoAutenticacao"
                      style="width: 100%;"
                      placeholder="Modo autenticação"
                      size="small"
                    >
                    <el-option
                      v-for="authMode in authModes"
                      :key="authMode.id"
                      :label="authMode.label"
                      :value="authMode.data"
                    />
                    </el-select>
                    <el-button @click="removerTestemunha(item)" type="text" icon="el-icon-delete" style="color: red;"></el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="criarAssinaturaHandler" type="primary" size="small">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Util from '../../../util/funcoes'
import { AUTH_MODE_ZAP_SIGN } from '../../../util/constantes';

export default {
  props: {
    visibility: Boolean
  },

  data() {
    return {
      form: {
        tipo: undefined,
        documento: undefined,
        aluguel: undefined,
        venda: undefined,
        imovelAluguel: undefined,
        imovelVenda: undefined,
        vistoria: undefined,
        diasValidade: 7,
        signatarios: []
      },

      testemunha: {
        nome: '',
        email: ''
      },

      testemunhas: [],

      clienteSelecionado: undefined,

      tiposDeDocumentos: [
        { label: 'Selecione', data: undefined },
        { label: 'Vistorias', data: 'VISTORIA' },
        { label: 'Alugueis', data: 'ALUGUEL' },
        { label: 'Vendas', data: 'VENDA' },
        { label: 'Imóveis Aluguel', data: 'IMOVEL_ALUGUEL' },
        { label: 'Imoveis Venda', data: 'IMOVEL_VENDA' }
      ],

      loadingDocumento: false,
      loadingAlugueis: false,
      loadingVendas: false,
      loadingImoveisAluguel: false,
      loadingImoveisVenda: false,
      loadingVistorias: false,

      visibilidadeAdicionarTestemunha: false,
    }
  },

  computed: {
    ...mapState('assinaturaEletronicaStore', {
      listaDocumentos(state) { return state.listaDocumentos },
      listaAlugueis(state) { return state.listaAlugueis },
      listaVendas(state) { return state.listaVendas },
      listaImoveisAluguel(state) { return state.listaImoveisAluguel },
      listaImoveisVenda(state) { return state. listaImoveisVenda },
      listaEnvolvidos(state) { return state.listaEnvolvidos },
      listaVistorias(state) { return state.listaVistorias }
    }),
    ...mapState({
      isLoading: state => state.loading,
    }),
    ...mapState("loginStore", {
      imobiliaria(state) {
        return state.usuarioLogado.imobiliaria;
      },
    }),

    labelDocumento() {
      return this.form.tipo === 'ALUGUEL' ? 'Documento de Aluguel' :
      this.form.tipo === 'VENDA' ? 'Documento de Venda' :
      this.form.tipo === 'IMOVEL_ALUGUEL' ? 'Documento de Imóvel de Aluguel' :
      this.form.tipo === 'IMOVEL_VENDA' ? 'Documento de Imóvel de Venda' : ''
    },

    exibirSelecionarDocumento() {
      return this.form.tipo !== 'VISTORIA' && this.form.tipo;
    },
    exibirSelecionarAluguel() {
      return this.form.tipo === 'ALUGUEL' && this.form.tipo;
    },
    exibirSelecionarVenda() {
      return this.form.tipo === 'VENDA' && this.form.tipo;
    },
    exibirSelecionarImovelAluguel() {
      return this.form.tipo === 'IMOVEL_ALUGUEL' && this.form.tipo
    },
    exibirSelecionarImovelVenda() {
      return this.form.tipo === 'IMOVEL_VENDA' && this.form.tipo
    },
    exibirSelecionarVistoria() {
      return this.form.tipo === 'VISTORIA' && this.form.tipo
    },
    authModes() {
      return AUTH_MODE_ZAP_SIGN
    },
    isExibirEnvolvidos() {
      return this.form.aluguel || this.form.venda || this.form.imovelAluguel || this.form.imovelVenda || this.form.vistoria
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('assinaturaEletronicaStore', [
      'listarDocumentos',
      'listarAlugueis',
      'listarVendas',
      'listarEnvolvidosAluguel',
      'criarAssinatura',
      'limparListas',
      'listarImoveis',
      'listarEnvolvidosAluguel',
      'listarAssinaturas',
      'listarEnvolvidosVenda',
      'listarEnvolvidosImovel',
      'listarImoveisVenda',
      'listarVistorias',
      'listarEnvolvidosVistoria'
    ]),
    tipoDocumentoDesativado(tipo) {
      switch (tipo) {
        case 'VISTORIA': {
          return this.imobiliaria.appVistoria 
        }
        case 'ALUGUEL': {
          return this.imobiliaria.moduloAluguel
        }
        case 'VENDA': {
          return this.imobiliaria.moduloVenda
        }
        case 'IMOVEL_ALUGUEL': {
          return this.imobiliaria.moduloAluguel
        }
        case 'IMOVEL_VENDA': {
          return this.imobiliaria.moduloVenda
        }
      }
    },
    getLabel(item) {
      return Util.getLabel(this.tiposDeDocumentos ,item)
    },
    recuperarDocumentosSelect(queryString) {
      let payload = { nome: queryString, tipo: this.form.tipo ? this.form.tipo : undefined }
      this.loadingDocumento = true;
      this.listarDocumentos(payload)
      .then(() => {
        this.loadingDocumento = false
      }).catch(() => {
        this.loadingDocumento = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },

    recuperarAlugueisSelect(queryString) {
      let payload = { idNaImobiliaria: queryString }
      this.loadingAlugueis = true;
      this.listarAlugueis(payload)
      .then(() => {
        this.loadingAlugueis = false;
      }).catch(() => {
        this.loadingAlugueis = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    recuperarVendasSelect(queryString) {
      let payload = { imovel: { idNaImobiliaria: queryString } }
      this.loadingVendas = true;
      this.listarVendas(payload)
      .then(() => {
        this.loadingVendas = false;
      }).catch(() => {
        this.loadingVendas = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      });
    },

    recuperarImoveisAluguelSelect(queryString) {
      let payload = { idNaImobiliaria: queryString, operacao: 'ALUGUEL'  }
      this.loadingImoveisAluguel = true;

      this.listarImoveis(payload)
      .then(() => {
        this.loadingImoveisAluguel = false;
      }).catch(() => {
        this.loadingImoveisAluguel = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    recuperarImoveisVendaSelect(queryString) {
      let payload = { idNaImobiliaria: queryString, operacao: 'VENDA'  }
      this.loadingImoveisVenda = true;

      this.listarImoveisVenda(payload)
      .then(() => {
        this.loadingImoveisVenda = false;
      }).catch(() => {
        this.loadingImoveisVenda = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    recuperarVistoriasSelect(queryString) {
      let payload = { status: 'CONCLUIDO' ,aluguel: { idNaImobiliaria: queryString } }

      this.loadingVistorias = true;

      this.listarVistorias(payload)
      .then(() => {
        this.loadingVistorias = false;
      }).catch(() => {
        this.loadingVistorias = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    listarEnvolvidosAluguelHandler() {
      const payload = {
        ...this.form.aluguel
      }

      this.listarEnvolvidosAluguel(payload)
      .then(resposta => {
        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor')  
        }
      })
      .catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor')
      })
    },

    listarEnvolvidosVendaHandler() {
      const payload = {
        ...this.form.venda
      }

      this.listarEnvolvidosVenda(payload)
      .then(resposta => {
        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor')  
        }
      })
      .catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor')
      })
    },

    listarEnvolvidosImovelAluguelHandler() {
      const payload = {
        ...this.form.imovelAluguel
      }

      this.listarEnvolvidosImovel(payload)
      .then(resposta => {
        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor')  
        }
      })
      .catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor')
      })
    },

    listarEnvolvidosImovelVendaHandler() {
      const payload = {
        ...this.form.imovelVenda
      }

      this.listarEnvolvidosImovel(payload)
      .then(resposta => {
        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor')  
        }
      })
      .catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor')
      })
    },

    listarEnvolvidosVistoriaHandler() {
      const payload = {
        ...this.form.vistoria
      }

      this.listarEnvolvidosVistoria(payload)
      .then(resposta => {
        if(resposta.status === 'ERRO') {
          this.$message.error('Erro ao comunicar-se com o servidor');
        }
      })
      .catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor');
      })
    },

    exibirAdicionarTestemunha() {
      this.visibilidadeAdicionarTestemunha = true;
    },

    fecharAdicionarTestemunha(testemunha) {
      this.visibilidadeAdicionarTestemunha = false;

      if(testemunha) {
        this.testemunhasContrato.push(testemunha)
      }
    },

    exibirFormularioTestemunha() {
      this.visibilidadeAdicionarTestemunha = true;
    },

    fecharFormularioTestemunha() {
      this.visibilidadeAdicionarTestemunha = false;
    },

    criarAssinaturaHandler() {
      this.showLoading();

      const payload = {
        tipo: this.form.tipo,
        documento: this.form.documento,
        aluguel: this.form.aluguel,
        venda: this.form.venda,
        imovel: this.form.tipo === 'IMOVEL_ALUGUEL' ? this.form.imovelAluguel : this.form.imovelVenda,
        vistoria: this.form.vistoria,
        signatarios: [...this.form.signatarios, ...this.testemunhas]
      }

      this.criarAssinatura(payload)
      .then(resposta => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success('Assinatura gravada com sucesso')
        }
      }).catch(() => {
        this.$message.error('Não foi possível conectar-se com o servidor.')
      }).finally(() => {
        this.hideLoading();
        this.fecharListarAssinaturas();
      });
    },

    adicionarRemoverSignatario(signatario) {
      if(this.form.signatarios.includes(signatario)) {
        let index = 0;
        let indexVistoriador = 0;
        if(signatario.vistoriador) {
          indexVistoriador = this.form.signatarios.findIndex(item => (item.vistoriador && item.vistoriador.id === signatario.vistoriador.id));
        }
        if(signatario.cliente) {
          index = this.form.signatarios.findIndex(item => (item.cliente && item.cliente.id === signatario.cliente.id)); 
        }
        this.form.signatarios.splice(index === -1 ? indexVistoriador : index, 1)
      } else {
        this.form.signatarios.push(signatario);
      }
    },

    adicionarTestemunha() {
      const testemunha = { ...this.testemunha, tipoSignatario: 'TESTEMUNHA', modoAutenticacao: 'ASSINATURA_TELA' }
      this.testemunhas.push(testemunha);
      this.visibilidadeAdicionarTestemunha = false;
      this.testemunha = { nome: '', email: '' }
    },

    removerTestemunha(testemunha) {
      const index = this.testemunhas.findIndex(item => item === testemunha);
      this.testemunhas.splice(index, 1);
    },

    reset() {
      this.form = {
        tipo: undefined,
        documento: undefined,
        aluguel: undefined,
        venda: undefined,
        imovelAluguel: undefined,
        signatarios: []
      }
    },

    limparCampos() {
      this.form = {
        ...this.form,
        documento: undefined,
        aluguel: undefined,
        venda: undefined,
        imovelAluguel: undefined,
        imovelVenda: undefined,
        diasValidade: 7,
        signatarios: []
      }
    },

    fechar() {
      this.reset();
      this.limparListas();
      this.$emit('close');
    },

    fecharListarAssinaturas() {
      this.reset();
      this.limparListas();
      this.$emit('close');
      this.listarAssinaturas({})
    },
  },
}
</script>

<style scoped>
  .background-signtario:hover {
    background-color: #dbfafa;
  }
</style>